import { each, pipe } from '@fxts/core';

/** @description form 태그를 nested 데이터로 만드는 함수로 name="a.b" value="c"로 지정하면 { a : { b : c }로 만들어집니다.} */
export const makeNestedFormDataToObject = (form: HTMLFormElement) => {
  const data = {};

  pipe(
    form,
    (form) => new FormData(form).entries(),
    each(([key, value]) => {
      const keys = key.split('.');
      keys.reduce((acc, cur, idx) => {
        if (idx === keys.length - 1) {
          acc[cur] = value;
        } else {
          acc[cur] = acc[cur] || {};
        }
        return acc[cur];
      }, data);
    }),
  );

  return data;
};
